module.exports = __webpack_public_path__ + "media/images/magnify-482af6cf1fd1debedef848d27db094ca.png";